export enum MicroserviceModule {
    Incidents = 1,
}
